import { Currency, Loading } from 'components'
import messages from 'i18n/messages'
import classNames from 'classnames'
import first from 'lodash/first'
import flowRight from "lodash/flowRight"
import { makeSelectDateById, extractDateId } from 'logic/dates'
import { claimCandidates, claimSeatsGetOrder, clearCandidates, setPriceForCandidate, makeSelectCandidates, makeSelectCandidateSeats, makeSelectErr, makeSelectLoading, toggleCandidate } from 'logic/orders'
import { makeSelectPctsByDateId } from 'logic/pcts'
import { withRouter } from 'next/router'
import React, { Component } from "react"
import { isMobile } from 'react-device-detect'
import { FormattedMessage } from 'react-intl'
import { connect } from "react-redux"
import { Button, DropdownItem, DropdownToggle, DropdownMenu, UncontrolledDropdown } from 'reactstrap'
import { Tooltip } from 'react-tippy'
import { bindActionCreators } from "redux"
import { createStructuredSelector } from "reselect"
import { makeSelectSeatPrices } from '../logic/orders'

const errorMsg = error => {
  const dict = {
    'maxTickets': <FormattedMessage {...messages.maxTicketsReached} values={{ max: 8 }} />,
    'noPartialBookingInSgr': <FormattedMessage {...messages.noPartialBookingInSgr} />,
  }
  if (dict[error.error]) return dict[error.error]
  
  return <FormattedMessage {...messages[messages[error.error] ? error.error : 'unknown']} />
}

const ShowError = ({ error }) => (
  <div className="help-block claiming-error text-danger">
    {errorMsg(error)}
  </div>
)

class Tickets4Basket extends Component {

  state = {
    open: false,
    mobileOpen: false,
    hasBeenOpened: false,
    tooltipOpen: false,
    tooltipSeen: false,
  }

  scrollEventSet = false

  componentDidMount() {
    this.setState({ open: !isMobile })
  }

  componentDidUpdate(props) {
    this.checkCheckoutWrapRef()
    this.checkShowMobileTooltip(props)
    if (props.seats.length === this.props.seats.length) return
    if (this.state.hasBeenOpened) return false
    this.setState({ hasBeenOpened: true, open: true })
  }

  checkShowMobileTooltip = props => {
    if (!props.seats || !props.pcts || props.candidates.length < 1) return

    const seat = props.seats.find(s => s.client_uid === props.candidates[0])
    if (!seat) return

    const pct = props.pcts.find(pct => pct.id === seat.price_category_id)
    if (!this.state.tooltipSeen
        && pct && pct.prices.length > 0
        && props.seats && props.seats.length > 0
        && isMobile)
      this.setState({ tooltipOpen: true, tooltipSeen: true })
  }

  updateCheckoutWrapRefOnScroll = e => {
    // TODO: Move element to bottom of visible area
    // el.offsetParent
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.updateCheckoutWrapRefOnScroll)
  }

  checkCheckoutWrapRef = () => {
    if (!this.refs.checkoutWrapRef) return
    if (this.scrollEventSet) return
    this.scrollEventSet = true
    document.addEventListener('scroll', this.updateCheckoutWrapRefOnScroll, { once: true })
  }

  handleToggleOpen = () => {
    if (!this.props.admin) return

    this.setState({ open: !this.state.open })
  }

  handleToggleTooltipOpen = () => this.setState({ tooltipOpen: !this.state.tooltipOpen })

  handleToggleMobileOpen = () => this.setState({ mobileOpen: !this.state.mobileOpen })

  handleClaimTickets = () => {
    if (this.props.admin) {
      this.props.actions.claimSeatsGetOrder(
        this.props.match.params.id
      )
      this.props.actions.clearCandidates()
      this.setState({ open: false })
      return
    }
    this.props.actions.claimCandidates(this.props.seats.map(seat => seat.id))
  }

  renderTempSeatsAmount = ({ candidates }) => (
    <div className="temp-seats-amount">
      {candidates ? candidates.length : '0'}
    </div>
  )

  renderTempSeatsLabel = amount => (
    <div className="temp-seats-label">
      <div className="tickets-text-label"><FormattedMessage {...messages.ticketsPlural} values={{ amount }} /></div>
      <div className="selected-text-label"><FormattedMessage {...messages.selected} /></div>
    </div>
  )

  setPrice = (price, candidate) =>
    this.props.actions.setPriceForCandidate(price, candidate)

  renderTempSeatsPrice = (candidate, { seats, date, pcts, seatPrices }) => {
    const seat = seats.find(s => s.client_uid === candidate)
    const pct = pcts.find(pct => pct.id === seat.price_category_id)
    if (!pct) return <div key={`d-${new Date()}`}>nopctyet</div>
    const price = seatPrices && seatPrices[candidate]
      ? pct.prices.find(prc => prc.id === seatPrices[candidate])
      : first(pct.prices)
    if (!price) return <div key={`d-${new Date()}`}>Reseller not allowed!</div>
    const removeCandidate = () => this.props.actions.toggleCandidate(candidate)
    return (
      <div className="seat-candidate" key={`c-${candidate}`} style={{ borderLeftColor: pct.color }}>
        <div className="seat-candidate-header">
          <div className="pct-name">
            {pct.name || <FormattedMessage {...messages.pctNum} values={{ num: pct.num }} />}
          </div>
          <div className="seat-price">
            <Currency value={price.value} />
          </div>
        </div>
        <div className="seat-infos-wrap">
          <div className="seat-infos">
            {date.show_section_seat_info
              ? <span>
                {seat.sec_name || <FormattedMessage {...messages.secNum} values={{ num: seat.sec_num }} />},&nbsp;
                </span>
              : null
            }
            {seat.sgr_name || <FormattedMessage {...messages.seatRow} />}&nbsp;
            {seat.sgr_num},&nbsp;
            {seat.label || <FormattedMessage {...messages.platz} />}&nbsp;
            {seat.override_num}
          </div>
          <div className="d-flex justify-content-between align-content-center">
            {pct.prices.length > 1
              ? <div className="seat-price-sel">
                  <UncontrolledDropdown>
                    <DropdownToggle color="link" caret>
                      {price.name}
                    </DropdownToggle>
                    <DropdownMenu>
                      {pct.prices.map(prc => (
                        <DropdownItem key={`prc-${prc.id}`} onClick={() => this.setPrice(prc, candidate)}>{prc.name}</DropdownItem>
                      ))}
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              : <div />
            }
            <div className="remove-seat" onClick={removeCandidate}>
              <i className="tt-icon tt-icon-bin" />
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderBasketButton = ({ loading }) => (
    <Button className="checkout-btn" block color="success" onClick={this.handleClaimTickets} disabled={loading}>
      {this.props.admin ? <i className="tt-icon tt-icon-receipt-list-42" /> : <i className="tt-icon tt-icon-shopping-cart" />}
      {loading
        ?
        <Loading color="white" width="1em" />
        : <FormattedMessage {...messages.checkout} values={{ count: this.props.candidates.length }} />
      }
    </Button>
  )

  renderClosedBasket = total => (
    <div className="basket-panel" onClick={this.handleToggleOpen}>
      <div className="rotated-overview">
        <div className="content">
          { total > 0
            ? <>
                <FormattedMessage {...messages.totalTicketsInBasket} values={{ qty: total }} />
                <div className="icon-container">
                  <i className="tt-icon tt-icon-up-arrow" />
                </div>
              </>
            : <div className="select-your-tickets">
                <FormattedMessage {...messages.selectYourTickets} />
              </div>
          }
        </div>
      </div>
    </div>
  )

  renderLoadingSeats = () => (
    <div className="basket-panel open">
      <div className="basket-panel-header">
        <i className="tt-icon tt-icon-right-arrow" onClick={this.handleToggleOpen} />
        <FormattedMessage {...messages.yourBasket} />
      </div>
      <div className="basket-panel-loading-wrap">
        <Loading />
        <div className="loading-text">
          <FormattedMessage {...messages.loadingDetails} />
        </div>
      </div>
    </div>
  )

  render() {
    const { candidates, seats, pcts, error, seatPrices } = this.props
    const { mobileOpen, tooltipOpen } = this.state
    if (!this.state.open) return this.renderClosedBasket(seats.length)
    let foundSeats = 0
    const total = candidates.reduce((acc, candidate) => {
      const seat = seats.find(s => s.client_uid === candidate)
      if (!seat) return acc
      foundSeats += 1
      const pct = pcts.find(pct => {
        return pct.id === seat.price_category_id
      })
      let price
      if (pct) {      
        price = seatPrices && seatPrices[candidate]
          ? pct.prices.find(prc => prc.id === seatPrices[candidate])
          : first(pct.prices)
      }
      return price ? acc + price.value : null
    }, 0)
    if (foundSeats !== candidates.length) return this.renderLoadingSeats()

    return (
      <div id="basket-panel" className={classNames('basket-panel open', { 'mobile-open': mobileOpen, 'has-errors': error && error.error })}>
        <div className="basket-panel-header">
          {this.props.admin
            ? <i className="tt-icon tt-icon-right-arrow" onClick={this.handleToggleOpen} />
            : <i className="tt-icon tt-icon-shopping-cart" />
          }
          <FormattedMessage {...messages.yourBasket} />
        </div>
        <div className="basket-panel-body">
          <div className="seat-candidates">
            {candidates.map(candidate => this.renderTempSeatsPrice(candidate, this.props))}
          </div>
          <div className="checkout-wrap" ref="checkoutWrapRef">
            <div className="checkout-wrap-info">
              {/* <Tooltip
                title="Zum Ändern des Tickettyps hier ausklappen"
                className="tippy-sel-info"
                position="bottom"
                arrow
                distance={70}
                onRequestClose={this.handleToggleTooltipOpen}
                trigger="manual"
                open={tooltipOpen}
                toggle={this.handleToggleTooltipOpen}
              > */}
                <div className="mobile-edit-btn" onClick={this.handleToggleMobileOpen}>
                  { mobileOpen
                    ? <span className="tt-icon tt-icon-down-arrow" />
                    : <span className="tt-icon tt-icon-up-arrow" />
                  }
                </div>
              {/* </Tooltip> */}
              {this.renderTempSeatsAmount(this.props)}
              {this.renderTempSeatsLabel(candidates.length)}
              {total > 0
                ? <div className="seat-candidates-total">
                  <div className="label"><FormattedMessage {...messages.total} /></div>
                  <div className="sum"><Currency value={total} /></div>
                </div>
                : null
              }
            </div>
            {error && error.error ? <ShowError error={error} /> : null}
            {candidates && candidates.length ? this.renderBasketButton(this.props) : null}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  seats: makeSelectCandidateSeats(),
  date: makeSelectDateById(props => extractDateId(props)),
  seatPrices: makeSelectSeatPrices(),
  error: makeSelectErr(),
  loading: makeSelectLoading(),
  pcts: makeSelectPctsByDateId(props => extractDateId(props)),
  candidates: makeSelectCandidates(),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    claimCandidates,
    toggleCandidate,
    clearCandidates,
    claimSeatsGetOrder,
    setPriceForCandidate,
  }, dispatch)
})

const enhance = flowRight(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)

export default enhance(Tickets4Basket)
